<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [hasDefault]="false"
  [columns]="null"
  (cancelChange)="cancel()"
  (submitChange)="save()"
  [isShowModal]="false">
  <ng-container class="content" *ngIf="columns?.length">
    <div class="page">
      <div class="page-header">
        <ssg-select
          name="BranchId"
          [group]="formGroup"
          [dataList]="BranchLookUp"
          [label]="'ClientApp.FrontOffice.Inv.DailyBalance.Branch' | translate"
          textFieldName="Title"
          valueFieldName="Id"
          userClass="select-sm"
          (valueChange)="loadInvDailyBalances()">
        </ssg-select>
      </div>
      <div class="grid-box">
        <editable-grid
          #grid
          [columns]="columns"
          [dataList]="dataList"
          [isAdd]="true"
          [isDelete]="true"
          [filtering]="true"
          [paging]="true"></editable-grid>
      </div>
    </div>
  </ng-container>
</dynamic-form>
